module.exports = __webpack_public_path__ + "img/02-thumb.ad39a1b9.png";